import { useAppDispatch, useAppState } from '~/app/contexts/app-context';
import {
	StyledNotification,
	StyledNotificationContainer,
} from '~/app/pages/components/notification/styled-notification';
import { Container, InnerContainer } from '~/styles/container';

export const ResponseNotification = () => {
	const { notificationData } = useAppState();
	const dispatch = useAppDispatch();
	const closeNotification = () => {
		dispatch({ type: 'SET_NOTIFICATION_DATA', payload: undefined });
	};

	return (
		<>
			<StyledNotificationContainer>
				<Container>
					<InnerContainer>
						<StyledNotification
							copy={notificationData?.copy || ''}
							icon={notificationData?.icon || 'info-circle'}
							title={{
								tag: 'h1',
								text: notificationData?.title?.text || '',
							}}
							closeButton={{
								ariaLabel: 'close',
								onClick: () => {
									closeNotification();
								},
							}}
							textLink={notificationData?.textLink}
							button={notificationData?.button}
							error={notificationData?.error}
						/>
					</InnerContainer>
				</Container>
			</StyledNotificationContainer>
		</>
	);
};
